import {
  Sidebar,
  SidebarDivider,
  SidebarExpandButton,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { usePortalAccess } from '../accessControl/AccessContext';
import { portalNavLabel } from './navLabels';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: function PortalSidebar({ navItems }) {
      const access = usePortalAccess();
      const nav = navItems.withComponent(item => (
        <SidebarItem
          icon={() => item.icon}
          to={item.href}
          text={portalNavLabel(item.node.spec.id, item.title)}
        />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:notifications'); // Using NotificationsSidebarItem manually instead
      nav.take('page:catalog-import'); // Repositories are cataloged automatically
      const catalog = nav.take('page:catalog');
      const scaffolder = nav.take('page:scaffolder');
      const repositoryMap = nav.take('page:repository-map');
      const ecosystemMap = nav.take('page:ecosystem-map');
      const catalogGraph = nav.take('page:catalog-graph');
      const apiDocs = nav.take('page:api-docs');
      const accessControl = nav.take('page:access-control');
      const deliveryPolicyGate = nav.take('page:delivery-policy-gate');
      const governanceAlerts = nav.take('page:governance-alerts');
      const auditCenter = nav.take('page:audit-center');
      const secretScan = nav.take('page:secret-scan');
      // Acesso por aplicação é decidido no backend (allowedEntityRefs); a tela
      // lista o que a pessoa pode gerir. Aqui só exige acesso liberado.
      const runtimeConfig = nav.take('page:runtime-config');

      return (
        <Sidebar>
          <SidebarLogo />
          {access?.permissions['catalog.read'] && (
            <SidebarGroup label="Pesquisa" icon={<SearchIcon />} to="/search">
              <SidebarSearchModal />
            </SidebarGroup>
          )}
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {access?.permissions['catalog.read'] && catalog}
            {access?.permissions['templates.execute'] && scaffolder}
            {access?.permissions['catalog.read'] && apiDocs}
            {access?.permissions['catalog.read'] && catalogGraph}
            {access?.permissions['repositories.read'] && repositoryMap}
            {access?.permissions['ecosystem.read'] && ecosystemMap}
            {access?.permissions['policy.read'] && deliveryPolicyGate}
            {access?.permissions['policy.read'] && governanceAlerts}
            {access?.permissions['policy.read'] && secretScan}
            {access?.enabled && runtimeConfig}
            {access?.permissions['audit.read'] && auditCenter}
            {access?.permissions['access.manage'] && accessControl}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarExpandButton />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Configurações"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
